export default "<div role=\"tooltip\"\n     aria-hidden=\"false\">\n    <p class=\"wrap\">{{ $ctrl.content }}</p>\n</div>\n";